// api/sidebarConfigApi.js
import axios from "axios";

const BASE_URL = axios.create({
  baseURL: `${process.env.REACT_APP_SOCKET_URL}/api/sidebar-config`,
});

const getHeaders = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
});

// 📖 Get sidebar sections/items filtered for the CURRENT logged-in user's role
// GET /api/sidebar-config
export async function getMySidebar() {
  try {
    const res = await BASE_URL.get(`/`, getHeaders());
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}

// 📖 Get the FULL raw config (every section/item, enabled or not) — SUPERADMIN/ADMIN only
// GET /api/sidebar-config/admin
export async function getFullSidebarConfig() {
  try {
    const res = await BASE_URL.get(`/admin`, getHeaders());
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}

// ✏️ Save the full edited sections array — SUPERADMIN/ADMIN only
// PUT /api/sidebar-config/admin   Body: { sections: [...] }
export async function updateSidebarConfig(sections) {
  try {
    const res = await BASE_URL.put(`/admin`, { sections }, getHeaders());
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}

// ♻️ Reset to hardcoded defaults — SUPERADMIN/ADMIN only
// POST /api/sidebar-config/admin/reset
export async function resetSidebarConfig() {
  try {
    const res = await BASE_URL.post(`/admin/reset`, {}, getHeaders());
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}